<div class="container-text-header">
    <h2 class="text-center ls-h2-section-title text-brand-10" [innerHTML]="block.titolo"></h2>
    <h3 class="text-center ls-p text-neutral-40" [innerHTML]="block.sottotitolo"></h3>
</div>